import { omit } from 'util/object'

export type Query = Record<string, string | undefined>
export type Params = Record<string, string | number | boolean | null | undefined>

export function parseUrl(url: string | null | undefined): URL | undefined {
  if (!url) return undefined
  try {
    return new URL(url)
  } catch (e) {
    console.error('bad url', url, e)
    return undefined
  }
}

export function toQuerySuffix(params: Params) {
  const query = new URLSearchParams(omit(params) as any)
  const suffix = query.size ? '?' + query.toString() : ''
  return suffix
}

export function getQuery(url: string | null | undefined): Query {
  if (!url) return {}
  const params = new URL(url, location.origin).searchParams
  return Object.fromEntries(params)
}

export function replaceQuery(url: string | null | undefined, params: Params): string | undefined {
  const u = parseUrl(url)
  if (!u) return undefined
  u.search = toQuerySuffix(params)
  return u.toString()
}

// Один и тот же файл может приезжать с разным query (например, ?measurements),
// поэтому фото сравниваем по пути, а не по строке url целиком.
export function getUrlPath(url: string | null | undefined): string | undefined {
  const u = parseUrl(url)
  if (!u) return undefined
  return u.origin + u.pathname
}
